<template>
  <Assessment
    parent-path="/child_assess"
    :childAccountNames="childAccountNames"
    :assess-data="assessData"
    :loading="loading"
    :page="currentPage"
    :page-total="pageTotal"
  />
</template>
<script>
import * as childAccountApi from "@/api/childAccount.js";
import Assessment from "@/components/Assessment";

export default {
  name: "ChildAssess",
  components: {
    Assessment
  },
  data() {
    return {
      assessData: [],
      currentPage: 1,
      pageTotal: null,
      loading: true,
      childAccountNames: []
    };
  },
  mounted() {
    this.getChildAccountName();
    this.getAssessList();
  },
  methods: {
    // 获取子账号项目名称
    async getChildAccountName() {
      try {
        let { data } = await childAccountApi.getChildAccountName();
        this.childAccountNames = data.data;
      } catch (error) {}
    },

    // 评估项目列表
    async getAssessList(page = 1, searchField = {}) {
      return new Promise((resolve, reject) => {
        this.loading = true;
        childAccountApi
          .getChildAssessList({
            page,
            ...searchField
          })
          .then(({ data }) => {
            this.assessData = data.data;
            this.currentPage = page;
            this.pageTotal = data.total;
            resolve();
          })
          .catch(error => {
            reject(error);
          });
        this.loading = false;
      });
    }
  }
};
</script>
